import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/About.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>{t('about.title')}</h1>
          <p>{t('about.subtitle')}</p>
        </div>
      </section>

      <section className="about-story section">
        <div className="container">
          <div className="about-content-grid">
            <div className="about-image">
              <div className="placeholder-image">🔮</div>
            </div>
            <div className="about-text">
              <p className="intro">{t('about.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2>{t('about.story.title')}</h2>
          <p>{t('about.story.text')}</p>
        </div>
      </section>

      <section className="section bg-gray">
        <div className="container">
          <h2>{t('about.approach.title')}</h2>
          <p>{t('about.approach.text')}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2>{t('about.certifications.title')}</h2>
          <ul className="certifications-list">
            {t('about.certifications.items', { returnObjects: true }).map((cert, index) => (
              <li key={index}>✓ {cert}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="section bg-gray">
        <div className="container">
          <h2 className="text-center">{t('about.values.title')}</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>{t('about.values.ethics.title')}</h3>
              <p>{t('about.values.ethics.description')}</p>
            </div>
            <div className="value-card">
              <h3>{t('about.values.empowerment.title')}</h3>
              <p>{t('about.values.empowerment.description')}</p>
            </div>
            <div className="value-card">
              <h3>{t('about.values.authenticity.title')}</h3>
              <p>{t('about.values.authenticity.description')}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
